import React, { useState, useEffect, useRef } from "react";
import {
  postSkillStandard,
  updateSkillStandard,
  getSkillStandard,
  getSkillSubjectAll,
} from "../../../api/skill.service";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import Constant from "../../../utils/constant";
import { Link, useNavigate, useLocation } from "react-router";
import Select from "react-select";
import { connect } from "react-redux";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { useNumericParam } from "../../../utils/useNumericParam";

const ManagePracticeStandards: React.FC<any> = (props: any) => {
  const location = useLocation();
  const [manageNotification, setManageNotification] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [contentTitle, setContentTitle] = useState<string>("");
  const [notificationIcon, setNotificationIcon] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [standardName, setStandardName] = useState<string>("");
  const [standardCode, setStandardCode] = useState<string>("");
  const [standardDescription, setStandardDescription] = useState<string>("");
  const [isApproved, setisApproved] = useState<boolean>(false);
  const [dropdownSelectedSubSkill, setdropdownSelectedSubSkill] =
    useState<any>(0);
  const [dropdownSelectedGrade, setdropdownSelectedGrade] = useState<any>(0);
  const standId = useNumericParam("id");
  const navigate = useNavigate();
  const [editStandards, seteditStandards] = useState<any>();
  const [newSubject, setNewSubject] = useState<any>("");
  const [newGrade, setNewGrade] = useState<any>("");
  const [newStateId, setNewStateId] = useState<number>(0);
  const [newGradeId, setNewGradeId] = useState<number>(0);
  const [newcontentAreaId, setcontentAreaId] = useState<number>(0);
  const [newOrderByColumn, setOrderByColumn] = useState<any>("name");
  const [SortDir, setSortDir] = useState<any>(false);
  const [subjectname, setSubjectname] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [subDrop, setSubDrop] = useState<any>([]);
  const [gradeData, setGradeData] = useState<any>([]);
  const [lang, setLang] = useState<number>(1);
  const [eSStandardName, setESStandardName] = useState<string>("");
  const [esStandardDescription, setESStandardDescription] =
    useState<string>("");

  useEffect(() => {
    setLoading(true);
    if (editStandards != null) {
      setStandardName(editStandards.name);
      setESStandardName(editStandards.spanishName);
      setisApproved(editStandards.isApproved);
      setStandardCode(editStandards.code);
      setStandardDescription(editStandards.description);
      setESStandardDescription(
        editStandards.spanishDescription
          ? editStandards.spanishDescription
          : editStandards.description
      );
      setdropdownSelectedSubSkill(editStandards.skillSubjectId);
      setdropdownSelectedGrade(editStandards.gradeId);
    }
    setLoading(false);
  }, [editStandards]);

  const getGradeData = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getGradeAll(999, pageNumber);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );

      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId,
          label: eachGradeData.name,
        };
      });
    }
    setGradeData(newGradeData);
  };

  useEffect(() => {
    async function skillSUbject() {
      const SubjectsResponse = getSkillSubjectAll(
        newStateId,
        newGradeId,
        newcontentAreaId,
        subjectname,
        true,
        true,
        0,
        newOrderByColumn,
        SortDir,
        pageSize,
        pageNumber
      );
      const subjectData = (await SubjectsResponse).data;
      const subject = subjectData.data.map((_g) => {
        return {
          label: _g.name,
          value: _g.skillSubjectId,
        };
      });
      setSubDrop(subject);
    }
    skillSUbject();
    getGradeData();
  }, [pageSize, pageNumber]);

  useEffect(() => {
    if (standId && standId > 0) {
      getSkillStandard(standId).then((response) => {
        const subjectType = {
          label: response?.data?.skillSubjectName,
          value: response?.data?.skillSubjectId,
        };
        const gradeType = {
          label: response?.data?.gradeName,
          value: response?.data?.gradeId,
        };
        seteditStandards(response.data);
        setNewSubject(subjectType);
        setNewGrade(gradeType);
      });
    }
  }, [standId]);

  const subjectArray = {
    name: standardName,
    spanishName: eSStandardName,
    isActive: true,
    isApproved: isApproved,
    userId: props.profile?.userId || 1,
    code: standardCode,
    skillSubjectId: newSubject.value,
    gradeId: newGrade.value,
    description: standardDescription,
    spanishDescription: esStandardDescription,
  };

  const inputstandardName = useRef<any>(undefined);
  const inputstandardCode = useRef<any>(undefined);
  const inputstandardDescription = useRef<any>(undefined);

  const onSumbit = () => {
    setManageNotification(true);
    if (standardDescription === "") {
      inputstandardDescription.current.focus();
    }
    if (standardCode === "") {
      inputstandardCode.current.focus();
    }
    if (standardName === "") {
      inputstandardName.current.focus();
    }
    if (
      standardName === "" ||
      standardCode === "" ||
      newSubject === "" ||
      newGrade === "" ||
      standardDescription === ""
    ) {
      setMessage("Data cannot be empty");
    } else {
      if (editStandards != null) {
        const editsubjectArray = {
          name: standardName,
          spanishName: eSStandardName,
          isActive: true,
          isApproved: isApproved,
          userId: props.profile?.userId || 1,
          code: standardCode,
          skillSubjectId: newSubject.value,
          gradeId: newGrade.value,
          description: standardDescription,
          skillStandardId: standId,
          spanishDescription: esStandardDescription,
        };
        updateSkillStandard(editsubjectArray).then((res) => {
          setNotificationIcon(true);
          setManageNotification(true);
          setContentTitle("Success");
          setMessage("Standard Added Successfully");
          navigate(Constant.SKILLPRACTICESTANDARD);
        });
      } else {
        postSkillStandard(subjectArray).then((res) => {
          setNotificationIcon(true);
          setManageNotification(true);
          setContentTitle("Success");
          setMessage("Standard Added Successfully");
          navigate(Constant.SKILLPRACTICESTANDARD);
        });
      }
    }
  };

  const updateMultiDropdownValues = (updateObj, type) => {
    if (type == "Subject") {
      setNewSubject(updateObj);
    } else if (type == "Grade") {
      setNewGrade(updateObj);
    }
  };

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Skill Practice Standard", url: Constant.SKILLPRACTICESTANDARD },
      {
        name: editStandards
          ? "Edit Skill Practice Standard"
          : "Add Skill Practice Standard",
        url: "",
      },
    ];

    if (standId) {
      items.push({ name: standId?.toString(), url: "" });
    }

    return items;
  };

  const toggleLang = () => {
    if (lang === 1) {
      setLang(2);
    } else {
      setLang(1);
    }
  };

  return (
    <AllowedTo
      perform={[
        Permissions.skill_practice_standard_create,
        Permissions.skill_practice_standard_modify,
      ]}
      no={() => <AccessDenied />}
    >
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {editStandards
                  ? "Edit Skill Practice Standard "
                  : "Add Skill Practice Standard"}
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <form>
              <div className="shadow py-6 border rounded-lg mt-5 px-4 w-1/4">
                <div className="flex justify-end">
                  <div
                    className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md mb-4"
                    onClick={() => toggleLang()}
                  >
                    <span
                      className={`${
                        lang === 1
                          ? "bg-primary-color text-white"
                          : "bg-white text-gray-400"
                      } inline-block dark:text-white w-20 py-0.5 text-center cursor-pointer hover:opacity-80`}
                    >
                      English
                    </span>
                    <span
                      className={`${
                        lang === 2
                          ? "bg-primary-color text-white"
                          : "bg-white text-gray-400"
                      } w-20 py-0.5 inline-block text-center  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                    >
                      Spanish
                    </span>
                  </div>
                </div>

                <div>
                  <div className="grid grid-cols-1">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        Topic Name
                        {lang === Constant.LANGUAGE.English && (
                          <span className="text-red-600">*</span>
                        )}
                      </label>
                    </div>
                    <div>
                      <input
                        id="Subject"
                        name="Subject"
                        value={standardName}
                        type="text"
                        ref={inputstandardName}
                        onChange={(e: any) => {
                          setStandardName(e.target.value);
                        }}
                        className={`${
                          lang === 1 ? "" : "hidden"
                        } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                        required
                      />

                      <input
                        type="text"
                        value={eSStandardName}
                        autoComplete="off"
                        className={`${
                          lang === 2 ? "" : "hidden"
                        } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                        onChange={(e) => setESStandardName(e.target.value)}
                      />

                      {standardName === "" && manageNotification === true && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Topic name is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700 whitespace-nowrap">
                        Topic code <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <div>
                      <input
                        id="standardCode"
                        name="Grade"
                        value={standardCode}
                        type="text"
                        ref={inputstandardCode}
                        onChange={(e: any) => {
                          setStandardCode(e.target.value);
                        }}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        required
                      />
                      {standardCode === "" && manageNotification === true && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Topic code is required
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        Subject <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <div
                      id="contentAreaFilter"
                      className="mt-1 block w-full py-2 focus:outline-none focus:ring-pink-700 focus:border-pink-700 sm:text-sm"
                    >
                      <Select
                        options={subDrop}
                        value={newSubject}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        onChange={(e) => {
                          updateMultiDropdownValues(e, "Subject");
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                      ></Select>
                      {newSubject === "" && manageNotification === true && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Subject is required
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        Grade <span className="text-red-600">*</span>
                      </label>
                    </div>

                    <div
                      id="grades"
                      className=" block w-full py-2 focus:outline-none focus:ring-pink-700 focus:border-pink-700 sm:text-sm"
                    >
                      <Select
                        options={gradeData}
                        value={newGrade}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        onChange={(e) => {
                          updateMultiDropdownValues(e, "Grade");
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                      ></Select>
                      {newGrade === "" && manageNotification === true && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Grade is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700 whitespace-nowrap">
                        Description
                        {lang === Constant.LANGUAGE.English && (
                          <span className="text-red-600">*</span>
                        )}
                      </label>
                    </div>
                    <div>
                      <div className="mt-1 block">
                        <textarea
                          id="Grade"
                          name="Grade"
                          value={standardDescription}
                          ref={inputstandardDescription}
                          onChange={(e: any) => {
                            setStandardDescription(e.target.value);
                          }}
                          className={`${
                            lang === 1 ? "" : "hidden"
                          } resize border w-full border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white`}
                        />

                        <textarea
                          id="description"
                          name="description"
                          value={esStandardDescription}
                          onChange={(e: any) => {
                            setESStandardDescription(e.target.value);
                          }}
                          className={`${
                            lang === 2 ? "" : "hidden"
                          } resize border w-full border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white`}
                        />
                      </div>
                      {standardDescription === "" &&
                        manageNotification === true && (
                          <span className="text-red-700 inline-block pt-1 text-sm">
                            Description is required
                          </span>
                        )}
                    </div>
                  </div>

                  <div className="flex items-center mt-5">
                    <div>
                      <input
                        id="isApproved"
                        name="isApproved"
                        type="checkbox"
                        checked={isApproved}
                        onChange={(e: any) => {
                          setisApproved(!isApproved);
                        }}
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                      />
                    </div>
                    <div className="text-sm ml-2">
                      <label className="font-medium text-gray-700 whitespace-nowrap">
                        Approved
                      </label>
                    </div>
                  </div>

                  <div className="flex justify-end mt-8 items-center border-t ">
                    <button
                      type="button"
                      className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                      onClick={onSumbit}
                    >
                      {editStandards ? "Update" : "Save"}
                    </button>
                    <Link to={Constant.SKILLPRACTICESTANDARD} className="ml-2">
                      <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                        Cancel
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(ManagePracticeStandards);
